import './SidebarMobile.scss';
import './Sidebar.css';
import {Drawer,} from "@mui/material";
import * as React from "react";
import {CollapsedSidebar} from "@moeindal/base-raiko-panel-components";
import {advanceSidebarItems} from "./SideBarItems";
import {useAuthState} from "../../context/AuthContext";

const SidebarMobile = () => {

    const {role: roles} = useAuthState();


    const [state, setState] = React.useState({
        left: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };
    return (
        <div className="header-content">
            {['left'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <div className="ic-menu" onClick={toggleDrawer(anchor, true)}/>
                    <Drawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                    >
                        <CollapsedSidebar advanceSidebarItems={advanceSidebarItems} roles={roles}/>
                    </Drawer>
                </React.Fragment>
            ))}
        </div>
    )
}
export default SidebarMobile;